export enum FileType {
  Image = "Image",
  JSON = "JSON",
  XML = "XML",
}
